<script lang="ts" setup>
import {onMounted, watch} from 'vue';

import EditorJS, {OutputData} from '@editorjs/editorjs';
import Header from '@editorjs/header';
import List from '@editorjs/list';
import Checklist from '@editorjs/checklist';
import Underline from '@editorjs/underline';
import Delimiter from '@editorjs/delimiter';
import Marker from '@editorjs/marker';
import CodeTool from '@editorjs/code';

const emits = defineEmits<{
  (event: 'update-note', claimTypeName: OutputData): void
}>();

const props = defineProps<{
  initialData?: OutputData;
  canEdit?: boolean
}>();

onMounted(() => {
  const editorjs = new EditorJS({
    holder: 'editorjs',
    readOnly: props.canEdit === false ? true : false,
    tools: {
      checklist: {
        class: Checklist,
        inlineToolbar: true,
      },
      underline: Underline,
      marker: Marker,
      // quote: Quote,
      header: Header,
      delimiter: Delimiter,
      list: List,
      code: CodeTool,
    },
    data: props.initialData || {
      blocks: []
    },
    onChange: async (api, event) => {
      const data = await api.saver.save()
      emits("update-note", data);
    },
  });

  watch(props, (newProps) => {
    editorjs.render(newProps.initialData as any)
  });
});
</script>
<template>
  <div id="editorjs"
       class="block w-full p-3 bg-white border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
  </div>
</template>
<style>
.codex-editor__redactor {
  padding-bottom: 0 !important;
}
</style>